import { ButtonLink } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Icon, Row } from '@repo/ui/components'

export const WalletActions = () => {
  const { t } = useTranslate()
  return (
    <Row className='justify-around w-full gap-xs'>
      <ButtonLink
        href='/wallet/deposit'
        variant='fill'
        color='neutral'
        size='sm'
        className='w-1/3'
        width='full'
        buttonClassName='w-full'
        startIcon={<Icon name='PlusLine' size='sm' />}
      >
        {t('walletPage_deposit')}
      </ButtonLink>
      <ButtonLink
        href='/wallet/withdraw/online-payment'
        variant='ghost'
        color='neutral'
        size='sm'
        className='w-1/3'
        buttonClassName='w-full'
        startIcon={<Icon name='ArrowUp' size='sm' />}
        width='full'
      >
        {t('walletPage_withdraw')}
      </ButtonLink>
      <ButtonLink
        href='/wallet/transfer'
        variant='ghost'
        color='neutral'
        size='sm'
        className='w-1/3'
        buttonClassName='w-full'
        startIcon={<Icon name='ArrowDownLeftArrowUpRight' size='sm' />}
      >
        {t('walletPage_transfer')}
      </ButtonLink>
    </Row>
  )
}
